import { render, staticRenderFns } from "./AssetEditor.vue?vue&type=template&id=01827288&scoped=true&"
import script from "./AssetEditor.vue?vue&type=script&lang=ts&"
export * from "./AssetEditor.vue?vue&type=script&lang=ts&"
import style0 from "./AssetEditor.vue?vue&type=style&index=0&id=01827288&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01827288",
  null
  
)

export default component.exports